export default __webpack_public_path__ + "static/media/2015.fc793a1f.jpg";